import TableComponent from '../../../Common/Charts/TableCharts';
import { number } from '../../../Common/Util/number';
import { useDetailsChartsDataContext } from './hooks/useDetailsChartsDataContext';
import { useSanitizeData } from '../../Common/hooks/useSanitizeData';

export const RubricAnualList = () => {
    const { chartData } = useDetailsChartsDataContext();

    const tableColumns = [
            {
                key: 'ano_registro_bo',
                header: 'Ano',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'rubrica',
                header: 'Rúbrica',
                headerStyle: { fontWeight: '700' },
                cellStyle: { fontWeight: '400' }
            },
            {
                key: 'total',
                header: 'Total',
                headerStyle: { fontWeight: '700', textAlign: 'right' },
                cellStyle: { textAlign: 'right', fontWeight: '400' },
                formatter: (value) => number.formatToBRNumber(value)
            }
    ];

    const rawData = chartData?.rubricEvolutionAnual || [];

    const flattenedData = rawData.flatMap((itemAno) => {
        return itemAno.rubricas.map((rubrica) => ({
            ...rubrica,
            ano_registro_bo: itemAno.ano_registro_bo
        }));
    });

    const sanitizedData = useSanitizeData(flattenedData);

    return (
        <div style={{ width: '100%' }}>
            <TableComponent
                data={sanitizedData}
                columns={tableColumns}
                title="Rúbricas Anuais"
                showTotal={true}
                totalColumn="total"
                formatNumber={number.formatToBRNumber}
                maxHeight="600px"
            />
        </div>
    );
};